import { MessageCircle, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSiteSetting } from "@/hooks/useSiteSetting";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import coupleTherapyImg from "@/assets/landing/couple-therapy.webp";

export default function LandingUrgencyCTA() {
  const whatsappPhone = useSiteSetting("whatsapp_phone", "5562994377238");
  const ref = useScrollReveal<HTMLDivElement>();

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={coupleTherapyImg}
          alt="Casal em terapia - caminho para recuperação"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-primary/80 dark:bg-primary/90" />
      </div>

      <div ref={ref} className="scroll-reveal relative z-10 max-w-5xl mx-auto px-4 py-20">
        <div className="max-w-3xl mx-auto text-center space-y-5">
          <span className="inline-block text-sm font-semibold text-primary-foreground/90 bg-primary-foreground/15 px-4 py-1.5 rounded-full backdrop-blur-sm">
            Abra o Caminho para a Recuperação Hoje
          </span>
          <h2 className="text-2xl sm:text-4xl font-bold text-primary-foreground">
            Não deixe a dependência controlar a vida da sua família
          </h2>
          <p className="text-sm sm:text-base text-primary-foreground/80 leading-relaxed max-w-xl mx-auto">
            Com nossa ajuda, você pode quebrar o ciclo de dependência e iniciar a jornada para
            uma vida mais feliz e saudável. A hora de agir é agora — cada momento conta.
            Junte-se às milhares de famílias que encontraram a liberdade da dependência.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
            <Button size="lg" variant="secondary" className="gap-2 shadow-lg text-base font-semibold" asChild>
              <a
                href={`https://wa.me/${whatsappPhone}?text=Olá! Preciso de ajuda urgente para encontrar uma clínica de reabilitação.`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <MessageCircle className="h-5 w-5" /> Peça Ajuda Agora
              </a>
            </Button>
            <Button size="lg" className="gap-2 shadow-lg text-base font-semibold bg-primary-foreground text-primary hover:bg-primary-foreground/90" asChild>
              <a href={`tel:+${whatsappPhone}`}>
                <Phone className="h-5 w-5" /> Ligar Agora
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
